import { useState } from "react";
import { useDispatch } from "react-redux";
import {
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogFooter
} from "@/components/ui/dialog";
import MainDetails from "../MainDetails";
import { Button } from "@/components/ui/button";
import Line from '@/components/CustomUI/modules/Loaders/Line';
import { removeItemFromCartApi, getCartDataApi } from "@/clientSideApi/cart";
import { setCartData } from "@/store/cart/cartSlice";
import { useAddWishlistItemMutation } from "@/store/wishlist/wishlistApiSlice";
import { addWishlistItem } from "@/store/wishlist/wishlistSlice";
import { generalEcomEvent } from "@/lib/utils";

const Container = ({ data, changeRemoveItemPopup }) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [addItem, { isLoading: addLoading }] = useAddWishlistItemMutation();

    const removeProductFromCart = async (internal = true) => {
        if (loading) return false;
        setLoading(true);
        const apiResponse = await removeItemFromCartApi({
            token: data.token,
        });
        if (!apiResponse) {
            setLoading(false);
            return false;
        }
        const cartApiResponse = await getCartDataApi();
        if (!cartApiResponse) {
            setLoading(false);
            return false;
        }

        dispatch(setCartData(cartApiResponse));
        generalEcomEvent({
            event: "remove_from_cart",
            other: {
                value: data.variant_price,
                currency: "INR",
            },
            items: [
                {
                    item_id: data.product.pk,
                    item_name: data.product.name,
                    item_category: data.product?.category?.name || "Ring",
                    price: data.variant_price,
                    item_brand: "ORNAZ",
                },
            ],
        });
        if (internal) {
            changeRemoveItemPopup(false);
            setLoading(false);
        }
        return true;
    };

    const moveProductToWishList = async () => {
        if (addLoading) return;
        const removeFromCart = await removeProductFromCart(false);
        if (!removeFromCart) return;
        dispatch(addWishlistItem(data.product.pk));
        addItem({ product_id: data.product.pk });
        generalEcomEvent({
            event: "add_to_wishlist",
            other: {
                value: data.variant_price,
                currency: "INR",
            },
            items: [
                {
                    item_id: data.product.pk,
                    item_name: data.product.name,
                    item_category: data.product?.category?.name || "Ring",
                    price: data.variant_price,
                    item_brand: "ORNAZ",
                },
            ],
        });
        changeRemoveItemPopup(false);
        setLoading(false);
    };

    return (
        <DialogContent
            className="
                w-screen md:w-[50vw] bg-white
                overflow-y-scroll vertical-scrollbar 
                flex flex-col
        "
        >
            <DialogHeader
                className="pb-3 pt-2 bg-white sm:text-center text-base md:text-lg lg:text-xl desktop:text-2xl font-black m-0"
            >
                <DialogTitle>
                    <span className="flex w-full items-center justify-center gap-x-3">
                        {`Remove  ${data.product.name}`}
                    </span>
                </DialogTitle>
            </DialogHeader>

            <MainDetails data={data} />

            <DialogFooter className="mt-4 gap-y-3 pb-4">
                <Button
                    aria-label="add to cart"
                    variant="outline"
                    className="
                        h-[33px] w-full  text-xs 
                        lg:text-sm select-none bg-white
                        text-font-button hover:drop-shadow
                        hover:bg-white
                        border-[0.5px] border-gray-400
                    "
                    onClick={removeProductFromCart}
                >
                    {loading ? <Line loading={true} /> : "Remove from Cart"}
                </Button>
                <Button
                    aria-label="add to cart"
                    variant="outline"
                    className="
                        h-[33px] w-full  text-xs 
                        lg:text-sm select-none bg-[#45D4D5]
                        text-font-button hover:drop-shadow
                        hover:bg-[#56f0f1]
                        border-[0.5px] border-gray-400
                    "
                    onClick={moveProductToWishList}
                >
                    {addLoading ? <Line loading={true} /> : "Add to Wishlist"}
                </Button>
            </DialogFooter>

        </DialogContent>
    )
}

export default Container